import React from 'react';
import PropTypes from 'prop-types';
import '../../../stylesheets/components/CustomSearchInputField.less';

// Custom input field with search icon to the left.

export default function CustomSearchInputField(props) {
  const { placeholder } = props;
  return (
    <div className="custom-search-input__container">
      <i className="glyphicon glyphicon-search" />
      <input
        name="query"
        className="custom-search-input__input form-control"
        placeholder={placeholder}
      />
    </div>
  );
}

CustomSearchInputField.propTypes = {
  placeholder: PropTypes.string,
};
